import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "./context/AppContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Listen from "./pages/Listen";
import Learn from "./pages/Learn";
import CourseDetail from "./pages/CourseDetail";
import Read from "./pages/Read";
import Article from "./pages/Article";
import EventDetail from "./pages/EventDetail";
import ManageRegistration from "./pages/ManageRegistration";
import Unsubscribe from "./pages/Unsubscribe";
import Gather from "./pages/Gather";
import Join from "./pages/Join";
import Login from "./pages/Login";
import MyTemple from "./pages/MyTemple";
import Admin from "./pages/Admin";
import Store from "./pages/Store";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Legal from "./pages/Legal";
import About from "./pages/About";
import Give from "./pages/Give";
import GiveThankYou from "./pages/GiveThankYou";
import ManageGiving from "./pages/ManageGiving";
import JoinThankYou from "./pages/JoinThankYou";
import HeartRequests from "./pages/HeartRequests";
import MerchProduct from "./pages/MerchProduct";
import MerchThankYou from "./pages/MerchThankYou";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/listen" element={<Listen />} />
            <Route path="/learn" element={<Learn />} />
            <Route path="/learn/:courseId" element={<CourseDetail />} />
            <Route path="/read" element={<Read />} />
            <Route path="/read/:id" element={<Article />} />
            <Route path="/gather" element={<Gather />} />
            <Route path="/gather/manage/:token" element={<ManageRegistration />} />
            <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
            <Route path="/gather/:eventId" element={<EventDetail />} />
            <Route path="/join" element={<Join />} />
            <Route path="/join/thank-you" element={<JoinThankYou />} />
            <Route path="/heart-requests" element={<HeartRequests />} />
            <Route path="/login" element={<Login />} />
            <Route path="/my-temple" element={<MyTemple />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/store" element={<Store />} />
            <Route path="/store/merch/thank-you" element={<MerchThankYou />} />
            <Route path="/store/merch/:productId" element={<MerchProduct />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/about" element={<About />} />
            <Route path="/give" element={<Give />} />
            <Route path="/give/thank-you" element={<GiveThankYou />} />
            <Route path="/give/manage/:token" element={<ManageGiving />} />
          </Routes>
        </Layout>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "var(--bg-cream)",
              color: "var(--text-obsidian)",
              border: "1px solid var(--gold-soft)",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
